<template>
    <input data-type="currency" type="text" v-model="content" @keyup="formatMoney" @change="finalForm" @focus="onFocus" @blur="onBlur" :readonly="readonly" />
</template>

<script>
    export default {
        props: ['value', 'readonly', 'isBlank'],
        data () {
            return {
                content: this.value,
                focusing: false,
                onfocus: false,
            };
        },
        mounted () {
            var id = uniqid();
            $(this.$el).attr("id", id);
            var parent = $(this.$el).parent();

            parent.prev().attr("for", id);
            parent.next().attr("id", id+"-message");

            this.content = this.initFormat();
        },
        watch: {
            content (n, o) {
                this.$emit('input', n);
            },
            value (val) {
                if (this.onfocus) {
                    this.content = this.value;

                    this.$nextTick(function () {
                        this.formatMoney({ keyCode: "" });
                    });
                } else {
                    this.content = this.initFormat()
                }
            }
        },
        methods: {
            onFocus(e) {
                this.onfocus = true;

                if (parseFloat(this.content) == 0) {
                    this.focusing = true;
                    this.content = null;
                    this.focusing = false;
                    return;
                }

                e.target.select();
            },
            onBlur() {
                if (this.content == null || this.content == '') {
                    this.focusing = true;
                    this.content = '0.00';
                    this.focusing = false;
                }

                this.onfocus = false;
            },
            finalForm() {
                if (this.focusing) {
                    return;
                }

                this.content = this.initFormat();
            },
            initFormat() {
                let float = this.value;
                if (typeof float == 'undefined' || float == null) float = "";
                float = String(float);
                float = parseFloat(float.replace(/,/g,''));
                if (isNaN(float)) float = 0;
                return this.isBlank && float === 0 ? '' : float.format(2);
            },
            formatMoney(e) {
                var $this = $(this.$el);
                var old = $this.data('old');
                var val = $this.val();

                if (!/\d|\.|,/.test(val) && val != "") {
                    $this.val(old);
                    return;
                }

                if (typeof old == 'undefined') {
                    old = "";
                }

                switch (e.keyCode) {
                    case 110:
                    case 190:
                        if (old.includes(".")){
                            $this.val(old);
                        }
                        return;
                    case 187:
                    case 188:
                        $this.val(old);
                        return;
                    case 32:
                        $this.data("old", val);
                        return;
                    default:
                        break;
                }

                var start = $this[0].selectionStart,
                end = $this[0].selectionEnd;

                var strip = val.replace(/,/g,'');
                if (strip.includes(".")) {
                    strip = strip.substring(0, strip.indexOf('.'));
                }

                var currency = parseFloat(strip);
                var formatted = currency.format();
                var decimal = val.substring(val.indexOf('.')+1);

                if (decimal.startsWith(0)&&decimal.length>1) {
                    decimal = "0" + parseInt(decimal);
                } else {
                    decimal = parseInt(decimal);
                }

                if (isNaN(decimal)) {
                    decimal = ".";
                } else {
                    decimal = "." + decimal;
                }

                if (val.includes('.')) {
                    formatted = formatted + decimal.substring(0, 3);
                }

                if (!isNaN(currency)) {
                    var c = (val.match(/,/g) || []).length - (formatted.match(/,/g) || []).length;
                    start = start - c;
                    end = end - c;
                    $this.val(formatted);
                    this.$emit('input', formatted);
                    $this[0].setSelectionRange(start, end);
                    $this.data('old', formatted);
                }
            }
        },
        destroyed() {
            this.onfocus = false;
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/elements/currency.vue